export const BOOKING_PRIMARY_COLOUR = "#0F4C5C"
